import { schemes, zSchema, EOrderStatus } from "@zeal/common";

export const handleFinixWebhooksRequestSchema = zSchema.object({
  webhookEvents: zSchema.array(zSchema.any()),
});

export type THandleFinixWebhooksRequestSchema = zSchema.infer<
  typeof handleFinixWebhooksRequestSchema
>;

export const handleFinixWebhooksResponseSchema = zSchema.object({
  orderUpdates: zSchema.array(
    zSchema.object({
      orderID: schemes.uuid(),
      companyID: schemes.uuid(),
      status: zSchema.nativeEnum(EOrderStatus),
    })
  ),
});

export type THandleFinixWebhooksResponseSchema = zSchema.infer<
  typeof handleFinixWebhooksResponseSchema
>;
